
const MessagesHost =()=>{

    return(
        <div>
        <h1>Messages</h1>
        </div>
    )
}
export default MessagesHost;
